class BannerContentLogoanimation extends HTMLElement {
    connectedCallback() {
        const videos = this.querySelectorAll('video');
        if (!videos.length) return;

        const observer = new IntersectionObserver(
          (entries) => {
              entries.forEach((entry) => {
                  if (!entry.isIntersecting) return;
                  this.loadVideo(entry.target);
                  observer.unobserve(entry.target);
              });
          },
          { threshold: 0.1 },
        );

        videos.forEach((video) => observer.observe(video));
    }

    loadVideo(video) {
        video.querySelectorAll('source[data-src]').forEach((source) => {
            source.src = source.dataset.src;
        });
        video.load();
        video.play().catch((err) => {
            console.warn('[banner-content-logoanimation] autoplay blocked:', err);
        });
    }
}

customElements.define('banner-content-logoanimation', BannerContentLogoanimation);
